import type React from 'react';

import { type Brand } from '@/consts/brands';
import { type TreatmentCategory } from '@/consts/treatmentCategories';
import { ProductSelectionAndCheckoutService } from '@/services/productSelectionAndCheckoutService/client';

export const setPatientViewedAt = async (
  brand: Brand,
  treatmentCategory: TreatmentCategory,
  hasViewedProductSelectionPage: boolean,
  setHasViewedProductSelectionPage: React.Dispatch<
    React.SetStateAction<boolean>
  >,
) => {
  if (!hasViewedProductSelectionPage) {
    setHasViewedProductSelectionPage(true);

    let numRetries = 0;

    const setPatientViewedAt = async () => {
      try {
        await ProductSelectionAndCheckoutService.setPatientViewedAt(
          brand,
          treatmentCategory,
        );
      } catch (exception) {
        if (numRetries < 5) {
          numRetries++;

          setTimeout(async () => {
            await setPatientViewedAt();
          }, 1000);
        }
      }
    };

    setPatientViewedAt();
  }
};
